export const DOMAIN_TEXT =
  'shared/services/bestPlaceAnalytics/fetchBestPlaceAnalyticsReportPrices#fetchGetCurrentPrice()';

export const DEFAULT_ERROR_MESSAGE =
  '[fetchBestPlaceAnalyticsReportPrices]: Ошибка получения данных о ценах аналитического отчета best place';
